import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const projectsApi = factory.get("projects");

const initialState = {
  projects: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 15,
      search: "",
    },
  },
  project: {
    form: {
      id: "",
      name: "",
    },
    dialog: false,
    loading: false,
    errors: {},
  },
};

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setProjects: (state, action) => {
      state.projects.data = action.payload.data.data;
      state.projects.total = action.payload.data.total;
    },
    setProject: (state, action) => {
      state.project.form = { ...action.payload.data };
    },
    resetForm: (state, action) => {
      state.project.form = initialState.project.form;
    },
    setFilters: (state, { payload }) => {
      state.projects.filters = {
        ...state.projects.filters,
        ...payload,
      };
    },
    setDialog: (state, { payload }) => {
      if (payload) {
        Object.keys(state.project.form).forEach((key) => {
          state.project.form[key] = payload[key];
        });
      } else {
        state.project.form = initialState.project.form;
      }
      state.project.dialog = !state.project.dialog;
    },
    resetFilters: (state) => {
      state.projects.filters = initialState.projects.filters;
    },
    clearProjects: (state) => {
      state.projects = initialState.projects;
    },
  },
});

export const {
  setLoading,
  setProjects,
  setProject,
  setFilters,
  resetFilters,
  setDialog,
  resetForm,
  clearProjects,
} = projectsSlice.actions;

export default projectsSlice.reducer;

//axios
const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().projects.projects.filters;
    dispatch(setLoading("projects"));
    const res = await projectsApi.index(filters);
    dispatch(setProjects(res));
    dispatch(setLoading("projects"));
  } catch (err) {
    dispatch(setLoading("projects"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const showById = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("project"));
    const res = await projectsApi.showById(id);
    dispatch(setProject(res));
    dispatch(setLoading("project"));
  } catch (err) {
    dispatch(setLoading("project"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const create = (data) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("project"));
    await projectsApi.create(data);
    dispatch(setLoading("project"));
    dispatch(
      showNotification({
        type: "success",
        message: "Project Created Successfully",
      })
    );
    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("project"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const update = (data) => async (dispatch, getState) => {
  try {
    const { id } = getState().projects.project.form;
    dispatch(setLoading("project"));
    await projectsApi.update(id, data);
    dispatch(setLoading("project"));
    dispatch(
      showNotification({
        type: "success",
        message: "Project Updated Successfully",
      })
    );
    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("project"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const Delete = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("project"));
    await projectsApi.delete(id);
    dispatch(
      showNotification({
        type: "success",
        message: "Project Deleted Successfully",
      })
    );
    dispatch(index());
    dispatch(setLoading("project"));
  } catch (err) {
    dispatch(setLoading("project"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

export const Projects = {
  index,
  showById,
  create,
  update,
  Delete,
};
